/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';

import { Card } from 'bundles/program-loggedin-shared/components/Card';

import alarmClockImage from 'images/degree-home/alarm-clock.png';

import _t from 'i18n!nls/degree-home';

import { useCoursesContext } from '../CoursesProvider';
import type { NormalizedNotStartedCourse } from '../types/courseStates';
import MobileUpcomingCoursesItemsList from './MobileUpcomingCoursesItemsList';
import UpcomingCoursesDescription from './UpcomingCoursesDescription';
import UpcomingCoursesItemsList from './UpcomingCoursesItemsList';

type InputProps = {
  supportEmailAddress?: string;
};

// Filters 'notStarted' courses to find items where is no active session, and there are no enrollable sessions.
const upcomingCoursesFilterFn = (course: NormalizedNotStartedCourse) => {
  return !course.activeSessionId && !course.hasEnrollableSession;
};

export const UpcomingCoursesCardContent = ({ supportEmailAddress }: InputProps) => {
  const { upcomingCoursesData } = useCoursesContext();
  const upcomingCourses = upcomingCoursesData?.filter(upcomingCoursesFilterFn);

  if (!upcomingCourses || upcomingCourses?.length < 1) return null;

  return (
    <Card aria-label={_t('Upcoming courses')} data-e2e="upcoming-courses-card">
      <img
        className="alarm-clock-icon"
        src={alarmClockImage}
        alt={_t('Alarm Clock Icon')}
        height="61"
        width="61"
        css={css`
          margin-bottom: 1rem;
        `}
      />
      {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
      <Typography
        component="h2"
        variant="h2semibold"
        color="body"
        css={css`
          padding-bottom: 1rem;
        `}
      >
        {upcomingCourses.length > 1 ? _t('Your courses are coming') : _t('Your upcoming course is coming')}
      </Typography>
      <UpcomingCoursesDescription upcomingCourses={upcomingCourses} supportEmailAddress={supportEmailAddress} />
      <UpcomingCoursesItemsList upcomingCourses={upcomingCourses} />
      <MobileUpcomingCoursesItemsList upcomingCourses={upcomingCourses} />
    </Card>
  );
};

export const UpcomingCoursesCard = (props: InputProps) => {
  return (
    <React.Fragment>
      <UpcomingCoursesCardContent {...props} />
    </React.Fragment>
  );
};

export default UpcomingCoursesCard;
